import { Errors, useErrorStore } from '@/composables/useErrorStore';

/**
 * Shows why joining the broadcast failed, for both Go Live and the library's automatic rejoin.
 * HOST_ALREADY_PRESENT means a different host account holds the channel.
 */
export const showJoinError = (error: unknown) => {
  useErrorStore().showError(
    error instanceof Error && error.cause === 'HOST_ALREADY_PRESENT'
      ? Errors.HostAlreadyPresent
      : Errors.DefaultError,
    {
      text: 'Try Again',
      action: () => window.location.reload(),
    }
  );
};
